import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import "../NegotiationsBarDetails/NegotiationsBarDetails.css";

function NegotiationBarMessages({ messagesList }) {
	const UID = useSelector(state => state.user.uid);
	const [messages, setMessages] = useState([]);
	//const [loading, setLoading] = useState(true);
	//const [loadingText, setLoadingText] = useState("Loading Garages, Please Wait...");
	const [date, setDate] = useState();
	const dummy = useRef();

	useEffect(() => {
		//setLoading(true);
		// console.log('Function---->', onClickNegotiation);
		if (messagesList && Object.keys(messagesList).length) {
			const addDateComponent = (date, timeStamp) => {
				let today = new Date();
				let actualDate = `${today.getDate()}/${today.getMonth() + 1
					}/${today.getFullYear()}`;
				let yesterday = `${today.getDate() - 1}/${today.getMonth() + 1
					}/${today.getFullYear()}`;
				return (
					<div
						key={timeStamp}
						className="NegotiationsBarDetails_container_conversationBox_messages_date"
					>
						{actualDate === date
							? "Today"
							: yesterday === date
								? "Yesterday"
								: date}
					</div>
				);
			};

			const getMessageComponents = (message, element) => {
				if (!date) {
					const Timestring = new Date(element.timeStamp);
							let actualDate = `${Timestring.getDate()}/${Timestring.getMonth() + 1
								}/${Timestring.getFullYear()}`;
					setDate(actualDate);
				}
				return (
					<div
						key={message}
						timestamp={element.timeStamp}
						className={`chat__message ${UID === element.UID ? "message--sent" : "message--received"
							} ${element.proposal ? "propusal--message" : ""}`}
					>
						{/* <span className="chat__message__sendedBy">
								{`${UID === element.UID ? "You": "Other"}:`}
							</span> */}
						{element.message}
						<span className="chat__message_time">{element.mSentDateTime}</span>
					</div>
				);
			};

			async function getMessages(messagesList) {
				let messagesContainer = [];
				let date = null;
				try {
					for (const message in messagesList) {
						// debugger
						if (messagesList.hasOwnProperty(message)) {
							const element = messagesList[message];
							const Timestring = new Date(element.timeStamp);
							let actualDate = `${Timestring.getDate()}/${Timestring.getMonth() + 1
								}/${Timestring.getFullYear()}`;

							if (!date) {
								// setDate(actualDate);
								date = actualDate;
								messagesContainer = [
									...messagesContainer,
									addDateComponent(actualDate, element.timeStamp),
									getMessageComponents(message, element)
								];
								// console.log("Primera entrada");
							} else {
								if (date === actualDate) {
									messagesContainer = [
										...messagesContainer,
										getMessageComponents(message, element)
									];
									// console.log("Casos iguales");
								} else {
									messagesContainer = [
										...messagesContainer,
										addDateComponent(actualDate),
										getMessageComponents(message, element)
									];
									date = actualDate;
									// setDate(actualDate);
									// console.log("Casos distintos");
								}
							}
							// debugger;
						}
						// console.log(messagesContainer);
					}
					return messagesContainer;
				} catch (err) {
					throw err;
				}
			}

			getMessages(messagesList).then(resp => {
				// console.log("negotiations results", resp);
				setMessages(() => [resp]);

				if (resp.length > 0) {
					setTimeout(() => {
						// setLoading(false);
					}, 500);
				} else {
					// setLoading(() => false);
					// setLoadingText("Oops, no messages found");
				}
			});
		} else {
			setMessages(() => { });
			// setLoading(() => false);
			// setLoadingText("Oops, no messages found");
		}
	}, [messagesList, UID]);

	useEffect(() => {
		dummy.current.scrollIntoView({ behavior: "smooth" });
	}, [messages]);

	return (
		<div className="NegotiationsBarDetails_container_conversationBox_messages">
			{messages && messages}
			<span ref={dummy} key={'dummySpecialKey'}></span>
		</div>
	);
}

export default NegotiationBarMessages;
